module.exports = __webpack_public_path__ + "resources/img/img_passxpertv4_4_m_en.c2abbc22005e9f71f613ca6a08cb1c60.png";